import { useEffect, useState } from "react";

const screens = {
	"2xl": "1536px",
	lg: "1024px",
	md: "768px",
	sm: "640px",
	xl: "1280px",
};

/**
 * Checks whether a particular Tailwind CSS viewport size applies.
 *
 * @param size The size to check, which must either be included in Tailwind CSS's
 * list of default screen sizes, or added to the Tailwind CSS config file.
 *
 * @returns A boolean indicating whether the viewport size applies.
 */
export const useBreakpoint = (size: "2xl" | "lg" | "md" | "sm" | "xl") => {
	const [matches, setMatches] = useState(() => {
		if (typeof window === "undefined") return true;
		return window.matchMedia(`(min-width: ${screens[size]})`).matches;
	});

	useEffect(() => {
		const breakpoint = window.matchMedia(`(min-width: ${screens[size]})`);

		// Update state asynchronously to avoid cascading renders
		queueMicrotask(() => {
			setMatches(breakpoint.matches);
		});

		const handleChange = (value: MediaQueryListEvent) =>
			setMatches(value.matches);

		breakpoint.addEventListener("change", handleChange);
		return () => breakpoint.removeEventListener("change", handleChange);
	}, [size]);

	return matches;
};
